import { useMemo, useState, useEffect } from "react";
import LoginModal from "../../Modal/LoginModal";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const openLoginPanel = () => {
    setIsLoginOpen(true);
  };

  return (
    <>
      <header className="sticky top-0 z-50 border-b border-white/50 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
          <a href="#home" className="flex items-center gap-3">
            <img
              src="/OPT4CRM-LOGO.SVG"
              alt="Opt4CRM logo"
              className="h-10 w-auto"
            />
          </a>

          <nav className="hidden items-center gap-8 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm font-semibold text-slate-700 transition hover:text-[#0B5ED7]"
              >
                {link.label}
              </a>
            ))}
            <button
              type="button"
              onClick={openLoginPanel}
              className="rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-[#0A2540] transition hover:-translate-y-0.5 hover:border-[#0B5ED7] hover:text-[#0B5ED7]"
            >
              Login
            </button>
            <a
              href="#pricing"
              className="rounded-full bg-[#0A2540] px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-slate-900/10 transition hover:-translate-y-0.5 hover:bg-[#0B5ED7]"
            >
              Start Free
            </a>
          </nav>

          <button
            type="button"
            onClick={() => setIsOpen((open) => !open)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 text-[#0A2540] transition hover:border-[#0B5ED7] hover:text-[#0B5ED7] md:hidden"
            aria-label="Toggle navigation"
            aria-expanded={isOpen}
          >
            <svg
              className="h-6 w-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6l12 12M18 6L6 18"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 7h16M4 12h16M4 17h16"
                />
              )}
            </svg>
          </button>
        </div>

        {isOpen ? (
          <div className="border-t border-slate-100 bg-white px-6 py-4 shadow-xl shadow-slate-900/5 md:hidden">
            <div className="mx-auto flex max-w-7xl flex-col gap-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setIsOpen(false)}
                  className="rounded-2xl px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 hover:text-[#0B5ED7]"
                >
                  {link.label}
                </a>
              ))}
              <button
                type="button"
                onClick={() => {
                  setIsOpen(false);
                  openLoginPanel();
                }}
                className="mt-2 rounded-2xl border border-slate-300 bg-white px-4 py-3 text-center text-sm font-semibold text-[#0A2540] transition hover:border-[#0B5ED7] hover:text-[#0B5ED7]"
              >
                Login
              </button>
              <a
                href="#pricing"
                onClick={() => setIsOpen(false)}
                className="rounded-2xl bg-[#0B5ED7] px-4 py-3 text-center text-sm font-semibold text-white shadow-lg shadow-blue-200"
              >
                Start Free
              </a>
            </div>
          </div>
        ) : null}
      </header>

      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </>
  );
}

export default Navbar;
